var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"disabled":!_vm.imageExists},on:{"click":_vm.clearDesign}},[_c('b-icon-plus-square',{attrs:{"aria-hidden":"true"}}),_vm._v(" New ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }